import { render, staticRenderFns } from "./ComplaintAllDealInfo.vue?vue&type=template&id=8ba5a7e4&"
import script from "./ComplaintAllDealInfo.vue?vue&type=script&lang=js&"
export * from "./ComplaintAllDealInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports